import { DataService } from "fg-library";
import { createBaseFormTemplate } from "./baseFormTemplate";
import {
  extractModelFields,
  generateListColumns,
  groupModelFieldsByFieldGroup,
} from "../dataUtils";
import { lisComponentTemplate } from "./listBaseTemplate";
import { listViewDefaulttemplate } from "./listviewtemplate";
import { firstValueFrom } from "rxjs";
import { getFilterDrawer } from "./filterDrawer";

import { generateFormFieldComponents } from "../createPage/cratePageGeneror";
import { getListHeader } from "./listheader";
import { calendarViewTemplate, getCalendarView } from "./calendarviewTemplate";
import { timelineTemplate } from "./timelineViewTemplate";
import { kanbanTemplate } from "./kanbanTemplate";
import { forEach } from "underscore";
import { generateCardViewTemplate } from "./cardviewTemplate";
import { getFilterForm } from "../common/filterGenerator";

export function CreateListPageTemplate(
  listView: any,
  typeCode: string,
  subTypeCode: string,
  searchableFields: any,
  title: string,
  isWorkflowModel: boolean
): any {
  listView.pageTitle = "";

  //3. Crearte a listComponent Template & Set tye and sub type from model.

  const listComponent = lisComponentTemplate;

  listComponent.typeCode = typeCode;
  listComponent.subTypeCode = subTypeCode;

  //4. set listView Template to template of  listComponent
  listComponent.template = JSON.stringify(listView);
  //console.log(listComponent.template);

  //5. Create base with list view
  const conditionFilters = buildEqualConditionFilters(searchableFields);
  const baseForm = createBaseFormTemplate(
    getListHeader(subTypeCode, title, isWorkflowModel),
    listComponent,
    conditionFilters
  );
  const pageSchema = [baseForm];



  const searchModal = getFilterForm(
    searchableFields,
  );

  const modals = {
    type: "fgContainer",
    children: [searchModal],
    uuid: crypto.randomUUID,
  };
  pageSchema.push(modals);

  //console.log(pageSchema);
  return pageSchema;
}

export function CreateTabularListPage(listFields: any): any {
  const listView = structuredClone(listViewDefaulttemplate);
  listView.pageTitle = "";

  const generatedListColumns = generateListColumns(listFields);
  listView.columns = generatedListColumns.columns;

  return listView;
}

export function CreateListViewPage(listFields: any): any {
  const listView = structuredClone(listViewDefaulttemplate);
  listView.pageTitle = "";
  const listViewLines = buildListViewLines(listFields);
  listView.listView.lines = listViewLines;

  return listView;
}
export function findFieldByName(fields: any[], nameValue: string) {
  return fields.find(
    (field) => field.name?.toLowerCase() === nameValue.toLowerCase()
  );
}


export function CreateCardViewPage(listFields: any): any {
  const listView = structuredClone(listViewDefaulttemplate);
  listView.pageTitle = "";
  const cardView = generateCardViewTemplate(listFields);
  const listViewLines = buildListViewLines(listFields);
  listView.cardView = cardView;
  listView.defaultWidget = "card";
  //console.log(listView);
  return listView;
}
export function CreateCalendatViewPage(
  listFields: any,
  startField: string,
  additionalFields: any
): any {
  const listView = structuredClone(listViewDefaulttemplate);

  listView.calendarView = getCalendarView(
    listFields,
    startField,
    additionalFields
  );

  return listView;
}

export function TimelineViewPage(listFields: any, timelineField: string): any {
  const listView = structuredClone(listViewDefaulttemplate);
  const timeLineView = timelineTemplate;
  const listViewLines = buildListViewLines(listFields);
  timeLineView.lines = listViewLines;
  timeLineView.timelineField = findFieldByName(listFields, timelineField);
  listView.timelineView = timeLineView;
  return listView;
}
export function getFieldsByNameList(
  fieldList: any[],
  nameList: string[]
): any[] {
  const lowerNameSet = new Set(nameList.map((name) => name.toLowerCase()));
  return fieldList.filter((field) =>
    lowerNameSet.has(field.name?.toLowerCase())
  );
}
export function KanbanViewPage(
  listFields: any,
  kanbanField: string,
  otherGroups: any
): any {
  const listView = structuredClone(listViewDefaulttemplate);
  const kanbanView = kanbanTemplate;
  const kanbanColumns = listFields.slice(0, 6);
  const keyField = findFieldByName(listFields, kanbanField);
  kanbanView.groupFields = getFieldsByNameList(listFields, otherGroups);
  kanbanView.kanbancolumns = kanbanColumns;
  kanbanView.titleField = listFields[0].name;
  kanbanView.subTitleField = listFields[1].name;
  kanbanView.typeLabel = keyField.displayName;
  listView.kanbanView = kanbanView;
  kanbanView.groupOptionalFields = getFieldsByNameList(listFields, otherGroups);

  return listView;
}





function buildEqualConditionFilters(fields: any[]): any[] {
  return fields.map((field) => ({
    sourceFieldCode: field.name,
    conditionVal: field.name,
    condition: "equal",
  }));
}



export function CreateListPage(
  listFields: any,
  typeCode: string,
  subTypeCode: string,
  searchableFields: any,
  title: string,
  isWorkflowModel: boolean,
  listVariation?: any,
  isComponentOnly?:boolean
): any {

  const basicListFields = extractBasicFieldInfo(listFields);



  if (!listVariation || listVariation.viewVariation =="Tabular") {
    const tabularListing = CreateTabularListPage(basicListFields);
     if(isComponentOnly) return tabularListing;
    const listPage = CreateListPageTemplate(
      tabularListing,
      typeCode,
      subTypeCode,
      searchableFields,
      title,
      isWorkflowModel
    );
    return listPage;
  }



  //List
  if (listVariation.viewName == "List") {
    const tabularListing = CreateListViewPage(basicListFields);
    tabularListing.defaultWidget = "List";
    if(isComponentOnly) return tabularListing;
    tabularListing.defaultWidget = "List";
    //console.log(tabularListing);
    const listPage = CreateListPageTemplate(
      tabularListing,
      typeCode,
      subTypeCode,
      searchableFields,
      title,
      isWorkflowModel
    );
    return listPage;
  }
  if (listVariation.viewName == "Card") {
    const cardListing = CreateCardViewPage(basicListFields);
    cardListing.defaultWidget = "card";
     if(isComponentOnly) return cardListing;
    cardListing.defaultWidget = "card";

    const listPage = CreateListPageTemplate(
      cardListing,
      typeCode,
      subTypeCode,
      searchableFields,
      title,
      isWorkflowModel
    );
    return listPage;
  }
  if (listVariation.viewName == "Calendar") {
    const calendarListing = CreateCalendatViewPage(
      basicListFields,
      listVariation.byField,
      listVariation.calendar
    );
  calendarListing.defaultWidget = "Calendar";
      if(isComponentOnly) return calendarListing;
  
    //console.log(calendarListing);
    const listPage = CreateListPageTemplate(
      calendarListing,
      typeCode,
      subTypeCode,
      searchableFields,
      title,
      isWorkflowModel
    );
    return listPage;
  }
  if (listVariation.viewName == "Timeline") {

    const timelineListing = TimelineViewPage(
      basicListFields,
      listVariation.byField
    );
timelineListing.defaultWidget = "Timeline";
   if(isComponentOnly) return timelineListing;
    
    //console.log(timelineListing);
    const listPage = CreateListPageTemplate(
      timelineListing,
      typeCode,
      subTypeCode,
      searchableFields,
      title,
      isWorkflowModel
    );
    return listPage;
  }

  //KanbanViewPage
  if (listVariation.viewName == "Kanban") {
    const timelineListing = KanbanViewPage(
      basicListFields,
      listVariation.byField,
      listVariation.kanban
    );
     timelineListing.defaultWidget = "Kanban";
     if(isComponentOnly) return timelineListing;
   
    //console.log(timelineListing);
    const listPage = CreateListPageTemplate(
      timelineListing,
      typeCode,
      subTypeCode,
      searchableFields,
      title,
      isWorkflowModel
    );
    return listPage;
  }
}

function extractBasicFieldInfo(
  fields: any[]
): { name: string; type: string; displayName: string }[] {
  return fields
    .filter((field) => field.name && field.type && field.displayName)
    .map((field) => ({
      name: field.name,
      type: field.type,
      displayName: field.displayName,
      asBadge:
        field.name?.toLowerCase().includes("status") ||
        field.name?.toLowerCase().includes("version")
          ? true
          : false,
      firstLetterIconEnabled: field.name?.toLowerCase().includes("name")
        ? true
        : false,
      dateFormat:
        field.type == "date" ? { dateFormat: "dd-MMM-yyyy" } : undefined,
      isPrefixIcon: field.type == "date" ? true : false,
      prefixIcon: field.type == "date" ? "fa fa-calendar" : "",
    }));
}

export function buildListViewLines(
  fields: { name: string; type: string; displayName?: string; tag?: string }[]
) {
  const transformField = (field: any) => ({
    ...field,
    fieldSpan: {
      name: "Six",
      code: "col-sm-6",
    },
  });

  const lineOneFields = fields.slice(0, 6).map(transformField);
  const lineTwoFields = fields.slice(6).map(transformField);

  const lines = [];

  if (lineOneFields.length > 0) {
    lines.push({
      lineNo: 1,
      fields: lineOneFields,
    });
  }

  if (lineTwoFields.length > 0) {
    lines.push({
      lineNo: 2,
      fields: lineTwoFields,
    });
  }

  return lines;
}


